import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import FormikTextCopiable from '../../../components/formik-components/FormikTextCopiable';
import { LegacyInputTextComponent } from '../../../components/prime-formik';

const DeleteTeamReportForm = ({ reportId }) => {
  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <FormattedMessage id="lbl.del_confirm.warning" defaultMessage="This action cannot be undone.">
          {(text) => <strong>{text}</strong>}
        </FormattedMessage>
      </div>
      <div className="p-col-12">
        <FormattedMessage id="lbl.confirmation_code" defaultMessage="Confirmation code">
          {(text) => <label htmlFor="confirmation_code">{text}</label>}
        </FormattedMessage>
        <Field name="confirmation_code" keyValue={reportId} component={FormikTextCopiable} readOnly />
      </div>
      <div className="p-col-12">
        <FormattedMessage id="lbl.confirmation_code_retype" defaultMessage="Please type the confirmation code">
          {(text) => <label htmlFor="re_confirmation_code">{text}</label>}
        </FormattedMessage>
        <div>
          <Field name="re_confirmation_code" component={LegacyInputTextComponent} />
        </div>
      </div>
    </div>
  );
};

DeleteTeamReportForm.propTypes = {
  reportId: PropTypes.string.isRequired,
};

export default DeleteTeamReportForm;
